import React,{useEffect,useState} from "react";
import MemberEngagementListTable from "./MemberEngagementListTable";
import { EngagementDetailsSummery,SummeryDashboardData, EngagementNotificationResult, Filterdashboard } from "../../met/utils/EngagementUtility";
import CalendarDatePicker from "../CalendarDatePicker";
import moment from "moment";
import { decryptData } from "../../utils/Utils";

function ContentMemberEngagementDetails() {

    const storedDates = localStorage.getItem('selectedDates') ? JSON.parse(decryptData(localStorage.getItem('selectedDates'))) : '';
    const [startDate, setStartDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[0]) : moment()
    );
    const [endDate, setEndDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[1]) : moment()
    );

    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate());
    
    const handleDateChange = ({ start, end }) => {
        setStartDate(start);
        setEndDate(end);
    };

    const [selectedProgram, setSelectedProgram] = useState('');

    const handleProgramChange = (event) => {
      setSelectedProgram(event.target.value);
    };

    

    return (
        <>
        <div className="ContentMemberEngagement mb-3">

        
            <div className="container-fluid px-0 mb-3 ">

                <div className="row align-items-center pb-3 sticky-top-bar">
                <div className="col-md text-start">
                        <h1 className="main-title">Member Engagement Manual - Phase 1</h1>
                </div>
                  {/* <Filterdashboard onChange={handleProgramChange} /> */}

                    <div className="col-md-3">
                    <CalendarDatePicker startDate={startDate} endDate={endDate} onDateChange={handleDateChange} />
                    </div>
                </div>
                <div className='reports-programs mb-3'>
                    <div className="row align-items-center">
                        <div className="col-md-auto">
                            <img src="https://appcdn.goqii.com/storeimg/45743_1720279919.png" alt="Invited Members icon" style={{height:"140px"}} className="img-fluid mb-0"/>
                        </div>
                        <div className="col-md">
                            <p className="mb-0">Enables admins to view an overview of member information by categories, including contacted, not contacted, enrolled, and not interested, for effective member management.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                    <div className="member-engagement px-3">
                            {/* <EngagementDetailsSummery /> */}
                            <SummeryDashboardData startDate={startDate} endDate={endDate} />
                        </div>
                    </div>
                    </div>
                        

                        {/* <div className="col-md-7">
                        <EngagementNotificationResult />
                        </div> */}


                </div>

                <div className='member-engagement mb-5'>
                <div className="row">
                    <div className="col-md-12">
                    <div className="table-responsive">
                        <MemberEngagementListTable startDate={startDate} endDate={endDate}/>
                    </div>
                    </div>
                </div>
                </div>

            </div>

        </>
    );
}

export default ContentMemberEngagementDetails;
